import React from 'react';
import { Action } from 'history';
import type { History, Transition } from 'history';
import { Navigator as BaseNavigator, UNSAFE_NavigationContext as NavigationContext } from 'react-router';

interface Navigator extends BaseNavigator {
  block: History['block'];
}

type NavigationContextWithBlock = React.ContextType<typeof NavigationContext> & { navigator: Navigator };

function useRouterPrompt(
  message: string,
  shouldBlock: boolean,
  callback: () => void,
  shouldPrompt: (tx: Transition) => boolean,
) {
  const { navigator } = React.useContext(NavigationContext) as NavigationContextWithBlock;

  React.useEffect(() => {
    if (!shouldBlock) return;

    const unblock = navigator.block((tx: Transition) => {
      if (tx.action === Action.Pop && shouldPrompt(tx)) {
        const confirmed = window.confirm(message);
        if (confirmed) {
          callback();
        }
      } else {
        unblock();
        tx.retry();
      }
    });

    return unblock;
  }, [navigator, shouldBlock, message, callback, shouldPrompt]);
}

export default useRouterPrompt;
